<kui-datetime
    [disabled]="field.readonly"
    [dateFormat]="dateFormat"
    [timeFormat]="timeFormat"
    [hourFormat]="hourFormat"
    [date]="value"
    [min]="field.min"
    [max]="field.max"
    [type]="datetimeType"
    [disableTime]="disableTime"
    [inputStyle]="'form-builder'"
    (onChange)="dateChanged($event)"
></kui-datetime>

@if (field.required && touched && !value) {
    <div class="invalid-feedback d-block">
        <div>{{ "FORMS.SHARED.REQUIRED" | translate: { field: field.title } }}</div>
    </div>
}

@if (error) {
    <div class="invalid-feedback d-block">
        <div>{{ error }}</div>
    </div>
}
